import moment from 'moment';
import _ from 'lodash';
import { LICENSE_CHAGES_TYPE, SERVICES_CODES, SERVICES_GROUPS, SERVICES_PROPERTIES } from 'app/config/services';
import { DOCUMENT_TYPES, DOCUMENT_TYPES_DESCRIPTION } from 'app/utils/constants';
import { filterDocumentsChangeEmail } from 'app/utils/forms/functions';

export const prepareStore = (request, documentsStore, documentsStoreVehicle, revisions, actualRevision) => {
    if (!request || !request.jsonSolicitacao) return [];
    const requestJsonData = JSON.parse(request.jsonSolicitacao);

    let fileStoreResult = [];
    const gerenalDocuments = {
        label: `Documentação Solicitação`,
        documents: [],
    };

    //GENERAL DOCUMENTATION
    const documentsJson = requestJsonData.documentos || [];
    documentsStore
        .filter((doc) => {
            return SERVICES_CODES.CHANGE_EMAIL === request.cdServico
                ? filterDocumentsChangeEmail(doc, requestJsonData)
                : true;
        })
        .forEach((doc) => {
            let temp = { ...doc };
            const found = _.find(documentsJson, ['cdTipoDocumento', doc.cdTipoDocumento]);
            if (found) {
                temp = { ...temp, ...found };
                if (!temp.fileName && found.name) {
                    temp.fileName = found.name;
                }
                if (found.idFile || found.file) {
                    temp.boAlterado = false;
                    temp.hasFile = true;
                }
            }
            gerenalDocuments.documents.push(temp);
        });
    //others
    const others = documentsJson.filter((o) => o.cdTipoDocumento === DOCUMENT_TYPES.OTHERS);
    others.forEach((o) => {
        gerenalDocuments.documents.push(o);
    });
    if (gerenalDocuments.documents.length > 0) {
        fileStoreResult.push(gerenalDocuments);
    }
    //END OF GENERAL DOCUMENTATION

    if (SERVICES_PROPERTIES[request.cdServico].payloadDocumentsGrouper) {
        const grouper = SERVICES_PROPERTIES[request.cdServico].payloadDocumentsGrouper;
        if (requestJsonData[grouper] && requestJsonData[grouper].length > 0) {
            requestJsonData[grouper].forEach((ele) => {
                let documents = ele.documentos || ele.veiculo?.documentos || [];
                if (request.cdServico === SERVICES_CODES.LICENCA_SEGUNDA_VIA) {
                    const changeType = requestJsonData.cdTipoAlteracaoLicenca;
                    const hasVehicleListInLicense = [
                        LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO,
                        LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO,
                        LICENSE_CHAGES_TYPE.MUDANCA_RAZAO_SOCIAL,
                    ];
                    if (!hasVehicleListInLicense.includes(changeType)) {
                        if (!ele.cdVeiculoAntigo && !ele.cdVeiculoSubstituir) {
                            return false;
                        }
                    }
                    if (ele.veiculoSubstituir?.documentos) {
                        documents = ele.veiculoSubstituir.documentos;
                    }
                }

                const result = {
                    label: `Documentação veiculo: ${ele.dePlaca || ele.veiculo?.dePlaca}`,
                    documents: [],
                };

                if (SERVICES_GROUPS.LICENSE.includes(request.cdServico)) {
                    documentsStoreVehicle.forEach((doc) => {
                        let temp = { ...doc };
                        const found = _.find(documents, ['cdTipoDocumento', doc.cdTipoDocumento]);
                        if (found) {
                            temp = { ...doc, ...found };
                            if (!temp.fileName && found.name) {
                                temp.fileName = found.name;
                            }
                            if (found.idFile || found.file) {
                                temp.boAlterado = false;
                                temp.hasFile = true;
                            }
                        }
                        if (!temp.cdVeiculo) {
                            temp.cdVeiculo = ele.cdVeiculo;
                        }
                        result.documents.push(temp);
                    });

                    //others
                    const others = documents.filter((o) => o.cdTipoDocumento === DOCUMENT_TYPES.OTHERS);
                    others.forEach((doc) => {
                        let temp = { ...doc };
                        if (!temp.cdVeiculo) {
                            temp.cdVeiculo = ele.cdVeiculo;
                        }
                        result.documents.push(temp);
                    });
                } else {
                    let preffix = ele.dePlaca || ele.veiculo?.dePlaca || '';
                    documents.forEach((doc) => {
                        let temp = { ...doc, preffix };
                        if (!temp.tipoDocumento && temp.cdTipoDocumento === DOCUMENT_TYPES.CRLV) {
                            temp.tipoDocumento = DOCUMENT_TYPES_DESCRIPTION[DOCUMENT_TYPES.CRLV];
                        }
                        if (!temp.tipoDocumento) {
                            const found = _.find(ele.veiculo?.documentos || [], ['cdTipoDocumento', temp.cdTipoDocumento]) || {};
                            if (found) {
                                temp.tipoDocumento = found?.tipoDocumento;
                            }
                        }
                        if (!temp.cdVeiculo) {
                            temp.cdVeiculo = ele.cdVeiculo;
                        }
                        result.documents.push(temp);
                    });
                }
                if (result.documents.length > 0) {
                    fileStoreResult.push(result);
                }
            });
        }
    }

    //REVISIONS
    const result = [];
    const docsOk = [];
    if (Object.keys(revisions).length > 0) {
        Object.keys(revisions).forEach((key) => {
            let lineCount = 0;
            const tempResult = fileStoreResult.map((fs) => {
                const resultInt = _.cloneDeep(fs);
                resultInt.documents = resultInt.documents.map((doc) => {
                    const fileChecked = checkFilesOnRevisions(doc, revisions[key]);
                    const temp = { ...doc, ...fileChecked };
                    docsOk[lineCount] = temp.boConformidade;
                    lineCount++;
                    return temp;
                });
                return resultInt;
            });
            result.push(tempResult);
        });
    }

    let lineCount = 0;
    const tempResult = fileStoreResult.map((fs) => {
        const resultInt = _.cloneDeep(fs);
        resultInt.documents = resultInt.documents.map((doc) => {
            let temp = { ...doc, boConformidade: docsOk[lineCount] || '' };
            if (actualRevision && Object.keys(actualRevision).length > 0) {
                const fileChecked = checkFilesOnRevisions(doc, actualRevision);
                temp = { ...doc, ...fileChecked };
            }
            lineCount++;
            return temp;
        });
        return resultInt;
    });

    result.push(tempResult);
    return result;
};

const checkFilesOnRevisions = (doc, revision) => {
    let result = {
        boConformidade: doc.boConformidade != null ? doc.boConformidade : '',
        deRevisaoDocumento: doc.deRevisaoDocumento || '',
    };
    if (doc.idFile) {
        if (revision.documentos) {
            const docs = _.find(revision.documentos, ['idFile', doc.idFile]);
            if (docs) {
                result = { ...docs };
            }
        }
    }
    return result;
};

export const validation = (documentsToRevision) => {
    const docIdFiles = documentsToRevision.filter((doc) => doc.idFile != null);
    return !(documentsToRevision.length === 0 || docIdFiles.length === 0);
};

export const prepareData = ({ request, documentsToRevision, actualRevision, generalObsertations, finalDate }) => {
    var sendingData = new FormData();
    if (actualRevision.cdRevisaoSolicitacao) {
        sendingData.append('cdRevisaoSolicitacao', actualRevision.cdRevisaoSolicitacao);
    }
    let observations = generalObsertations;
    sendingData.append('cdSolicitacao', request.cdSolicitacao);
    sendingData.append('deRevisao', observations);
    sendingData.append('dtVencimentoRevisao', moment.utc(finalDate).format('YYYY-MM-DD'));

    if (request.cdUsuarioResponsavel) {
        sendingData.append('cdUsuarioResponsavelTmp', request.cdUsuarioResponsavel);
    }

    let cont = 0;
    documentsToRevision.forEach((doc) => {
        if (doc.idFile == null) return;

        sendingData.append(`documentos[${cont}].boConformidade`, doc.boConformidade ? doc.boConformidade : false);
        if (doc.boDocumentoObrigatorio) {
            sendingData.append(`documentos[${cont}].boDocumentoObrigatorio`, doc.boDocumentoObrigatorio);
        }
        sendingData.append(
            `documentos[${cont}].deRevisaoDocumento`,
            doc.deRevisaoDocumento ? doc.deRevisaoDocumento : '',
        );
        sendingData.append(`documentos[${cont}].cdTipoDocumento`, doc.cdTipoDocumento);

        if (doc.boAlterado) sendingData.append(`documentos[${cont}].boAlterado`, doc.boAlterado);

        if (doc.deDescricao) sendingData.append(`documentos[${cont}].deDescricao`, doc.deDescricao);
        if (doc.nmTipoDocumento) sendingData.append(`documentos[${cont}].nmTipoDocumento`, doc.nmTipoDocumento);
        if (doc.deTipoDocumento) sendingData.append(`documentos[${cont}].deTipoDocumento`, doc.deTipoDocumento);

        if (doc.cdVeiculo) sendingData.append(`documentos[${cont}].cdVeiculo`, doc.cdVeiculo);

        if (doc.cdRevisaoSolicitacaoDoc) {
            sendingData.append(`documentos[${cont}].cdRevisaoSolicitacaoDoc`, doc.cdRevisaoSolicitacaoDoc);
        }

        if (actualRevision.cdRevisaoSolicitacao) {
            sendingData.append(`documentos[${cont}].cdRevisaoSolicitacao`, actualRevision.cdRevisaoSolicitacao);
        }

        if (doc.idFile) {
            sendingData.append(`documentos[${cont}].idFile`, doc.idFile);
        }
        if (doc.idGdoc) {
            sendingData.append(`documentos[${cont}].idGdoc`, doc.idGdoc);
        }

        let fileName = doc.fileName ? doc.fileName : doc.name;
        if (fileName) {
            sendingData.append(`documentos[${cont}].fileName`, fileName);
        }
        cont++;
    });

    return sendingData;
};
